import React from "react";
import { ConfirmPopup } from "primereact/confirmpopup";
import { Dialog } from "primereact/dialog";
import CommonButton from './commonButton';
import { useTranslation } from 'react-i18next';
import popup_close from '../../assests/images/popup_close.png'
const ConfirmAlert = ({ visible, onHide, message, onConfirm }) => {
  const { t } = useTranslation("translation");
    const footer = (
        // <div style={{
        //   display: "flex",
        //   justifyContent: "flex-end",
        //   gap: "10px",
        //   width: "100%",
        
  
        // }}>
        // <CommonButton onClick={onConfirm} icon="pi pi-check" label={t("text_button_confirms")} variant="success"   className="btn btn-success mt-3  btn-alert-popup-width input-style-common text-white btn-padding"></CommonButton>
        // <CommonButton onClick={onHide}  label={t("text_button_cancel")}  variant="cancel"   className="btn btn-cancel mt-3 btn-alert-popup-width input-style-common btn-cancel-style  pl-2 btn-padding primary-text-color"/>
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          width: "100%",
        }}>
          {/* Primary Button (Confirm) */}
          <CommonButton 
            onClick={onConfirm} 
            icon="pi pi-check" 
            label={t("text_button_confirms")} 
            variant="success" 
            className="custom-btn primary-btn-popup"
          />
          
          {/* Secondary Button (Cancel) */}
          <CommonButton 
            onClick={onHide}  
            label={t("text_button_cancel")}  
            variant="cancel"   
            className="custom-btn secondary-btn-popup"
          />
        </div>
      
      );
  return (
    <Dialog
    visible={visible}
    onHide={onHide}
    header={t("text_button_confirms")}
    modal
    style={{ width: '25vw' }} 
    closable={false}
    footer={footer}
    onShow={() => document.activeElement.blur()}
    draggable={false}
  >
     <button className="custom-close-icon mt-3" onClick={onHide}>
    <img src={popup_close} alt="Close" />
  </button>
    <p>{message}</p>
  </Dialog>
  );
};

export default ConfirmAlert;

